import React from "react";

// layout to be used for Login/Register views
const LayoutAuth = ({ children, title, subtitle, maxWidthClass = "sm:max-w-md", compact = false, alignTop = false }) => (
  <div
    className={`h-full min-h-screen overflow-y-auto bg-theme-secondary flex flex-col ${
      alignTop ? "justify-start" : "justify-start sm:justify-center"
    } ${compact ? "py-6" : "py-12"} sm:px-6 lg:px-8`}
  >
    <div className={`sm:mx-auto sm:w-full ${maxWidthClass}`}>
      <svg className={`mx-auto w-auto ${compact ? "h-8" : "h-12"}`} viewBox="0 0 54 33" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M27 0C12 0 0 12 0 27C0 29.2091 0.234219 31.3507 0.680627 33.4C1.12703 31.3507 1.36125 29.2091 1.36125 27C1.36125 13.8579 12.3579 2.86125 25.5 2.86125C38.6421 2.86125 49.6387 13.8579 49.6387 27C49.6387 29.2091 49.873 31.3507 50.3194 33.4C50.7658 31.3507 51 29.2091 51 27C51 12 39 0 27 0Z" fill="var(--theme-primary)"/>
        <path d="M27 13.5C20.0964 13.5 14.5 19.0964 14.5 26C14.5 27.3807 14.7801 28.6904 15.2801 29.9C15.7801 28.6904 16.0602 27.3807 16.0602 26C16.0602 20.4772 20.4772 16.0602 26 16.0602C31.5228 16.0602 35.9398 20.4772 35.9398 26C35.9398 27.3807 36.2199 28.6904 36.7199 29.9C37.2199 28.6904 37.5 27.3807 37.5 26C37.5 19.0964 31.9036 13.5 25 13.5H27Z" fill="var(--theme-primary)"/>
      </svg>
      <h2 className={`${compact ? "mt-3 text-xl" : "mt-6 text-3xl"} text-center font-extrabold text-theme-text`}>
        { title }
      </h2>
      {subtitle ? (
        <p className={`${compact ? "mt-1" : "mt-2"} text-center text-sm text-theme-text opacity-80 max-w`}>
          { subtitle }
        </p>
      ) : ''}
    </div>

    <div className={`${compact ? "mt-4" : "mt-8"} sm:mx-auto sm:w-full ${maxWidthClass}`}>
      <div className={`bg-theme-main shadow rounded-md sm:rounded-lg mx-4 sm:mx-0 border border-theme-secondary ${
        compact ? "py-4 px-4 sm:px-6" : "py-8 px-4 sm:px-10"
      }`}>
        { children }
      </div>
    </div>
  </div>
);

export default LayoutAuth;
